"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SvgBtUnblock = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var SvgBtUnblock = function SvgBtUnblock(props) {
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    d: "M6 22L22 6M14 22C15.5822 22 17.129 21.5308 18.4446 20.6518C19.7602 19.7727 20.7855 18.5233 21.391 17.0615C21.9965 15.5997 22.155 13.9911 21.8463 12.4393C21.5376 10.8874 20.7757 9.46197 19.6568 8.34315C18.538 7.22433 17.1126 6.4624 15.5607 6.15372C14.0089 5.84504 12.4003 6.00347 10.9385 6.60897C9.47672 7.21447 8.22729 8.23985 7.34824 9.55544C6.46919 10.871 6 12.4178 6 14C6 16.1217 6.84285 18.1566 8.34314 19.6569C9.84344 21.1571 11.8783 22 14 22Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M9 13C9 12.7239 9.22386 12.5 9.5 12.5H18.5C18.7761 12.5 19 12.7239 19 13V15C19 15.2761 18.7761 15.5 18.5 15.5H9.5C9.22386 15.5 9 15.2761 9 15V13Z",
    stroke: "currentColor"
  }));
};

exports.SvgBtUnblock = SvgBtUnblock;